import { DatePipe } from '@angular/common';
import { Component, computed, effect, Inject, OnInit, Signal, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatLuxonDateModule, provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { discountTypes, MY_DATE_FORMATS, PredefinedDiscounts } from '../../../domain/registrator';

@Component({
  selector: 'app-promocode-edit',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatLuxonDateModule,
    MatCheckboxModule,
    MatSlideToggleModule,
  ],
  providers: [
    provideLuxonDateAdapter(),
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ],
  templateUrl: './promocode-edit.component.html',
  styleUrl: './promocode-edit.component.scss'
})
export class PromocodeEditComponent implements OnInit {
  // DiscountType = DiscountType;
  predefinedDiscounts = PredefinedDiscounts;
  editMode: boolean = false;
  discountTypeOptions = discountTypes;

  form!: FormGroup;
  readonly discountTypeSignal!: Signal<string>;
  readonly percentDiscountSignal!: Signal<string>;
  // readonly showFixedAmount = computed(() => this.discountTypeSignal() === 'FIXED_AMOUNT');
  // readonly showPercentDiscount = computed(() => this.discountTypeSignal() === 'PERCENT');
  // readonly showCustomPercent = computed(() => this.discountTypeSignal() === 'PERCENT' && this.percentDiscountSignal() === 'custom');

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<PromocodeEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      code: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(20), Validators.pattern('^[a-zA-Z0-9_-]+$')]],
      comment: [''],
      maxUses: [1, [Validators.required, Validators.min(0)]],
      validUntil: [null, Validators.required],
      active: [true],
      discountType: ['PERCENT', Validators.required],
      percentDiscount: [0],
      customPercentDiscount: [0],
      fixedAmountDiscount: [0]
    });
    this.discountTypeSignal = toSignal(this.form.get('discountType')!.valueChanges,
      { initialValue: this.form.get('discountType')!.value });
    this.percentDiscountSignal = toSignal(this.form.get('percentDiscount')!.valueChanges,
      { initialValue: this.form.get('percentDiscount')!.value });

    effect(() => {
      const discountType = this.discountTypeSignal();
      console.log('Discount type effect: ', discountType);
      this.setValidators();
    });

    effect(() => {
      const percentDiscount = this.percentDiscountSignal();
      console.log('Percent discount effect: ', percentDiscount);
      this.setValidators();
    });
  }

  private setValidators(): void {
    if (this.form.value.discountType === 'PERCENT') {
      this.form.get('percentDiscount')!.setValidators([Validators.required]);
      if (this.form.value.percentDiscount === 'custom') {
        this.form.get('customPercentDiscount')!.setValidators([Validators.required, Validators.min(1), Validators.max(100)]);
      }
    } else if (this.form.value.discountType === 'FIXED_AMOUNT') {
      this.form.get('fixedAmountDiscount')!.setValidators([Validators.required, Validators.min(0)]);
    } else {
      this.form.get('percentDiscount')!.clearValidators();
      this.form.get('customPercentDiscount')!.clearValidators();
      this.form.get('fixedAmountDiscount')!.clearValidators();
    }
    this.form.get('percentDiscount')!.updateValueAndValidity({ emitEvent: false });
    this.form.get('customPercentDiscount')!.updateValueAndValidity({ emitEvent: false });
    this.form.get('fixedAmountDiscount')!.updateValueAndValidity({ emitEvent: false });
  }

  ngOnInit(): void {
    console.log('Data received in dialog:', this.data);
    if (this.data && this.data.code) {
      this.editMode = true;
      this.form.patchValue({
        code: this.data.code.code,
        comment: this.data.code.description,
        maxUses: this.data.code.maxUses,
        active: this.data.code.active,
        validUntil: this.data.code.validUntil ? new Date(this.data.code.validUntil) : null,
        discountType: (this.data.code.discountType ? this.data.code.discountType : 'PERCENT'),
        percentDiscount: (this.data.code.discountType === 'PERCENT' ? this.predefinedDiscounts.includes(this.data.code.discountValue) ? this.data.code.discountValue : 'custom' : 0),
        customPercentDiscount: (this.data.code.discountType === 'PERCENT' ? this.predefinedDiscounts.includes(this.data.code.discountValue) ? null : this.data.code.discountValue : 0),
        fixedAmountDiscount: (this.data.code.discountType === 'FIXED_AMOUNT' ? this.data.code.discountValue : 0)
      });
      //       if (this.data.code.discountType === 'PERCENT') {
      //         this.form.get('discountType')!.setValue('PERCENT');
      //         if (this.predefinedDiscounts.includes(this.data.code.discountValue)) {
      //           this.form.get('percentDiscount')!.setValue(this.data.code.discountValue);
      //         } else {
      //           this.form.get('percentDiscount')!.setValue('custom');
      //           this.form.get('customPercentDiscount')!.setValue(this.data.code.discountValue);
      //           this.form.get('customPercentDiscount')!.setValidators([Validators.required, Validators.min(1), Validators.max(100)]);
      //         }

      //       } else if (this.data.code.discountType === 'FIXED_AMOUNT') {
      // this.form.get('discountType')!.setValue('FIXED_AMOUNT');
      //         this.form.get('fixedAmountDiscount')!.setValue(this.data.code.discountValue);
      //       }
      console.log('Form initialized in edit mode with values:', this.form.value);
    }
  }

  get discountValue(): number | null {
    console.log('Calculating discount value for code type:', this.form.value.discountType);
    if (this.form.value.discountType === 'PERCENT') {
      return this.form.value.percentDiscount === 'custom'
        ? this.form.value.customPercentDiscount
        : this.form.value.percentDiscount;
    } else if (this.form.value.discountType === 'FIXED_AMOUNT') {
      return this.form.value.fixedAmountDiscount;
    }
    return null;
  }

  submit(): void {
    if (this.form.valid) {
      const datePipe = new DatePipe('en-US');
      const payload = {
        code: this.form.value.code,
        comment: this.form.value.comment,
        validUntil: datePipe.transform(this.form.value.validUntil, 'yyyy-MM-dd'),
        active: this.form.value.active,
        discountType: this.form.value.discountType,
        discountValue: this.discountValue,
        maxUses: this.form.value.maxUses
      };
      this.dialogRef.close(payload);
    }
  }
}
